import { createSelector } from 'reselect';
import { Big } from 'big.js';

import {
    getSubTotal,
    getGrandTotalCost,
    getShippingTotal,
    getFeesTotal,
    getItemAccessoriesGrandTotalCost
} from '../item/itemSelectors';
import {
    getDiscountRewardAmount
} from '../promo/promoSelectors';
import { getIntlLocale } from '../intl/intlSelectors';
import payPalLocaleMap from './data/paypalLocaleMap';


export const getPaypalPaymentRequest = createSelector(
    getGrandTotalCost,
    getSubTotal,
    getShippingTotal,
    getFeesTotal,
    getItemAccessoriesGrandTotalCost,
    getDiscountRewardAmount,
    (total, subtotal, shippingTotal, feesTotal, itemAccessoriesTotal, discount) => ({
        intent: 'AUTHORIZE',
        purchase_units: [
            {
                amount: {
                    value: total.toFixed(2),
                    currency_code: 'USD',
                    breakdown: {
                        item_total: {
                            value: new Big(subtotal).add(itemAccessoriesTotal).add(discount).toFixed(2),
                            currency_code: 'USD'
                        },
                        shipping: {
                            value: shippingTotal.toFixed(2),
                            currency_code: 'USD'
                        },
                        handling: {
                            value: feesTotal.toFixed(2),
                            currency_code: 'USD'
                        }
                    }
                }
            }
        ]
    })
);


export const getPaypalLocaleCode = createSelector(
    getIntlLocale,
    locale => payPalLocaleMap.get(locale, 'en_US')
);
